import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=791bc579&scoped=true"
import script from "@/views/Questionnaire/Question.ts?vue&type=script&lang=ts&external"
export * from "@/views/Questionnaire/Question.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Questionnaire/question.scss?vue&type=style&index=0&id=791bc579&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791bc579",
  null
  
)

export default component.exports